<template>
  <div class="acomodar">
    <div class="d-flex flex-column flex-lg-row w-100">
     
      <DatoPersonal />
    </div>
  </div>
</template>

<script>

import DatoPersonal from "@/components/ModPerfil/Mis_Datos_Generales/Datos_User.vue";
export default {
  name: "CopiasDatos",
  components: { DatoPersonal },
  data() {
    return {};
  },

  mounted() {},

  created() {
    this.cambiarEstadoNavbar();
  },

  methods: {
    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },
  },
};
</script>

<style scoped>
.acomodar {
  box-shadow: rgba(22, 22, 22, 0.2) 0px 2px 8px 0px;
  width: 100%;
  margin-right: 0.5rem !important;
  margin-top: 9px;
  margin-bottom: 9px;
  background: rgb(255, 255, 255);
  min-height: 100vh;
  overflow-x: auto;
  overflow-y: hidden;
}
</style>
